var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"header",class:['sidebar-header', 'gradient-royal-purple-to-boston-blue']},[_c('div',{staticClass:"header-title"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"close-button-container"},[_c('CloseButton')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }